<div class="section-container" id="skills">
    <div class="section-left">
      <h2>{{strings.skills}}</h2>
    </div>

    <div class="section-right">
      <div class="skills-section-wrapper">
        <div class="section-title">
          <h2 [innerHTML]="strings.skillsSectionTitle"></h2>
          <div class="section-subtitle">
            <p>{{strings.skillsSectionSubtitle}}</p>
            <img class="mouse-drag" src="assets/drag-icon.webp" alt="Mouse drag icon" loading="lazy">
          </div>
        </div>
        <div class="skills-section-content">
          <div class="horizontal-line"></div>
          <div class="skills-card">
            <img src="assets/skills/angular.webp" alt="Angular logo" class="skill-logo" loading="lazy">
            <h1>Angular</h1>
            <p>{{strings.angular}}</p>
          </div>
          <div class="skills-card">
            <img src="assets/skills/net.webp" alt=".Net logo" class="skill-logo" loading="lazy">
            <h1>.NET</h1>
            <p>{{strings.net}}</p>
          </div>
          <div class="skills-card margin-top-icon">
            <img src="assets/skills/react.webp" alt="React logo" class="skill-logo" loading="lazy">
            <h1>React</h1>
            <p>{{strings.react}}</p>
          </div>
          <div class="skills-card">
            <img src="assets/skills/laravel.webp" alt="Laravel logo" class="skill-logo" loading="lazy">
            <h1>Laravel</h1>
            <p>{{strings.laravel}}</p>
          </div>
          <div class="skills-card margin-top-icon">
            <img src="assets/skills/react-native.webp" alt="React Native logo" class="skill-logo" loading="lazy">
            <h1>React Native</h1>
            <p>{{strings.reactNative}}</p>
          </div>
          <div class="skills-card">
            <img src="assets/skills/typescript.webp" alt="Typescript logo" class="skill-logo" loading="lazy">
            <h1>TypeScript</h1>
            <p>{{strings.typescript}}</p>
          </div>
          <div class="skills-card margin-top-icon">
            <img src="assets/skills/php.webp" alt="PHP logo" class="skill-logo" loading="lazy">
            <h1>PHP</h1>
            <p>{{strings.php}}</p>
          </div>
          <div class="skills-card">
            <img src="assets/skills/mysql.webp" alt="MySQL logo" class="skill-logo" loading="lazy">
            <h1>MySQL</h1>
            <p>{{strings.mysql}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
